import { createApp } from 'vue';
import SvgVue from 'svg-vue3';
import Arc from './charts/Arc.vue';
import Bar from './charts/Bar.vue'
import Equivalencies from './charts/Equivalencies.vue'
import GoalsDoughnut from './charts/GoalsDoughnut.vue';
import ProgramDoughnut from './charts/ProgramDoughnut.vue';
import BubbleViz from './charts/BubbleViz.vue';

const arcChart = document.querySelector('#arc-chart');
const barChart = document.querySelector('#bar-chart');
const equivalencyCharts = document.querySelectorAll('.equivalency-chart');
const goalsDoughnutChart = document.querySelector('#goals-doughnut-chart');
const programDoughnutChart = document.querySelector('#program-doughnut-chart');
const bubbleViz = document.querySelector('#bubbleviz-chart');

export default function () {
  if (arcChart) {
    createApp(Arc, {...arcChart.dataset}).mount(arcChart);
  }

  if (barChart) {
    createApp(Bar, {...barChart.dataset}).mount(barChart);
  }

  if (equivalencyCharts) {
    equivalencyCharts.forEach((chart) => {
      createApp(Equivalencies, {...chart.dataset}).use(SvgVue).mount(chart);
    });
  }
  
  if (goalsDoughnutChart) {
    createApp(GoalsDoughnut, {...goalsDoughnutChart.dataset}).mount(goalsDoughnutChart);
  }

  if (programDoughnutChart) {
    createApp(ProgramDoughnut, {...programDoughnutChart.dataset}).mount(programDoughnutChart);
  }

  if (bubbleViz) {
    createApp(BubbleViz, {...bubbleViz.dataset}).mount(bubbleViz);
  }
}
